// extracted by mini-css-extract-plugin
export default {"Intro":"Intro_Intro__TtFkk","row":"Intro_row__qGw4p","img":"Intro_img__Ov3FS","content":"Intro_content__jtFQy"};